import React, {Component} from 'react';
import '../../styles/Home.css'
import {Button} from "react-bootstrap";
import LoginService from "../../admin/loginComponents/LoginService";
import Dropzone from 'react-dropzone'
import BiletyMiesieczneService from "../panel/panelComponents/mojeBiletyComponents/BiletyMiesieczneService";
import Crop from "../../admin/adminComponents/galeriaComponents/Crop";
import {confirmAlert} from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import {NotificationManager} from "react-notifications"; // Import css

export default class RejestracjaComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            imie: '',
            nazwisko: '',
            pesel: '',
            numerDokumentu: '',
            nrDokWaznyDo: '',
            nrDokSkan: '',
            miejscowosc: '',
            kodPocztowy: '',
            ulica: '',
            numerDomu: '',
            numerMieszkania: '',
            dataUrodzenia: null,
            telefon: '',
            zdjecie: [],
            zdjecieShow: '',
            zdjecieShow2: '',
            zdjecieShowZapisane: '',
            czyWeryfikacja: false,
            loading: false,
            imieInvalid: false,
            nazwiskoInvalid: false,
            peselInvalid: false,
            numerDokumentuInvalid: false,
            miejscowoscInvalid: false,
            kodPocztowyInvalid: false,
            ulicaInvalid: false,
            numerDomuInvalid: false,
            numerMieszkaniaInvalid: false,
            telefonInvalid: false,
            zdjecieInvalid: false,
            zdjecieInvalid2: false,
            aktualizacjaLoader: false
        };

        this.handleImie = this.handleImie.bind(this);
        this.handleNazwisko = this.handleNazwisko.bind(this);
        this.handlePesel = this.handlePesel.bind(this);
        this.handleNumerDokumentu = this.handleNumerDokumentu.bind(this);
        this.handleMiejscowosc = this.handleMiejscowosc.bind(this);
        this.handleKodPocztowy = this.handleKodPocztowy.bind(this);
        this.handleUlica = this.handleUlica.bind(this);
        this.handleNumerDomu = this.handleNumerDomu.bind(this);
        this.handleNumerMieszkania = this.handleNumerMieszkania.bind(this);
        this.handleTelefon = this.handleTelefon.bind(this)
    }

    componentWillMount() {
        LoginService.getKlient(JSON.parse(sessionStorage.getItem('loggedIn')).idKl, JSON.parse(sessionStorage.getItem('loggedIn')).login, JSON.parse(sessionStorage.getItem('loggedIn')).pass)
            .then(function (response) {
                let res = response.data;

                let zdjecie = [];

                for (let i = 0; i < res.pliki.length; i++) {
                    if (res.pliki[i].dokumentTyp === 'KLIENT_ZDJECIE') {
                        zdjecie.push(res.pliki[i])
                    }
                }

                this.setState({
                    imie: res.imie,
                    nazwisko: res.nazwisko,
                    pesel: res.pesel,
                    numerDokumentu: res.nrDok,
                    nrDokWaznyDo: res.nrDokWaznyDo,
                    nrDokSkan: res.nrDokSkan,
                    dataUrodzenia: res.dataUrodzenia,
                    miejscowosc: res.miejscowosc,
                    kodPocztowy: res.kodPoczt,
                    ulica: res.ulica,
                    numerDomu: res.nrDomu,
                    numerMieszkania: res.nrMieszk,
                    telefon: res.nrTel,
                    zdjecieShowZapisane: zdjecie,
                    zdjecia: res.pliki,
                    loading: true
                })
            }.bind(this)).catch(err => {
            console.log(err);
        });

        // WERYFIKACJA KART

        BiletyMiesieczneService.getKarty(JSON.parse(sessionStorage.getItem('loggedIn')).idKl)
            .then(function (response) {
                let weryfikacja = false;
                for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].status === 'NOWA') {
                        weryfikacja = true
                    }
                }
                this.setState({czyWeryfikacja: weryfikacja})
            }.bind(this)).catch(err => {
            console.log(err);
        });


    }

    componentDidMount() {
        if (this.props.props.notify === true) {
            NotificationManager.info("", "Najpierw uzupełnij dane wymagane do wykonania wybranego działania ", 5000)
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextProps.props.notify === true && (nextProps.props.notify !== this.props.props.notify)) {
            NotificationManager.info("", "Najpierw uzupełnij dane wymagane do wykonania wybranego działania ", 5000)
            return true;
        } else {
            return true;
        }
    }

    closeModal() {
        this.setState({cropTrue: false})
    }

    handleImie(e) {
        this.setState({imie: e.target.value})
    }

    handleNazwisko(e) {
        this.setState({nazwisko: e.target.value})
    }

    handlePesel(e) {
        this.setState({pesel: e.target.value})
    }

    handleNumerDokumentu(e) {
        this.setState({numerDokumentu: e.target.value})
    }

    handleMiejscowosc(e) {
        this.setState({miejscowosc: e.target.value})
    }

    handleKodPocztowy(e) {
        this.setState({kodPocztowy: e.target.value})
    }

    handleUlica(e) {
        this.setState({ulica: e.target.value})
    }

    handleNumerDomu(e) {
        this.setState({numerDomu: e.target.value})
    }

    handleNumerMieszkania(e) {
        this.setState({numerMieszkania: e.target.value})
    }

    handleTelefon(e) {
        this.setState({telefon: e.target.value})
    }

    onDrop(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({zdjecieInvalid: true, zdjecie: '', zdjecieShow: ''})
        } else {
            this.getBase64(accepted);
            this.setState({zdjecieInvalid: false, zdjecie: accepted})
        }
    }

    getBase64(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState({
                zdjecieShow2: [{
                    dane: reader.result.substr(reader.result.indexOf(',') + 1),
                    nazwa: file[0].name,
                    typ: file[0].type,
                    rozmiar: file[0].size,
                    dokumentTyp: "KLIENT_ZDJECIE"
                }],
                cropItem: 'data:' + file[0].type + ';base64, ' + reader.result.substr(reader.result.indexOf(',') + 1),
                cropTrue: true
            })
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    validatePesel(pesel) {
        let reg = /^[0-9]{11}$/;
        if (pesel.length === 0) {
            return true;
        } else {
            if (reg.test(pesel) === false) {
                return false;
            } else {
                let dig = ("" + pesel).split("");
                let kontrola = (1 * parseInt(dig[0]) + 3 * parseInt(dig[1]) + 7 * parseInt(dig[2]) + 9 * parseInt(dig[3]) + 1 * parseInt(dig[4]) + 3 * parseInt(dig[5]) + 7 * parseInt(dig[6]) + 9 * parseInt(dig[7]) + 1 * parseInt(dig[8]) + 3 * parseInt(dig[9])) % 10;
                if (kontrola === 0) kontrola = 10;
                kontrola = 10 - kontrola;
                return parseInt(dig[10]) === kontrola;
            }
        }
    }

    deleteNowy(image) {
        let images = this.state.zdjecieShow;
        images = images.filter(el => el !== image);
        this.setState({zdjecieShow: images})
    }


    deleteIstniejacy(image) {
        LoginService.deletePlik(image.id)
            .then(function (response) {
                let images = this.state.zdjecieShowZapisane;
                images = images.filter(el => el !== image);
                this.setState({zdjecieShowZapisane: images, zdjecieShow: []});
                NotificationManager.success("", "Zdjęcie zostało pomyślnie usunięte z serwera ", 5000)
            }.bind(this));

        let storage = JSON.parse(sessionStorage.getItem('loggedIn'));
        storage.pliki = [];
        sessionStorage.setItem('loggedIn', JSON.stringify(storage))
    }

    dokonczRejestracje() {
        this.setState({aktualizacjaLoader: true})

        let imie = true, nazwisko = true, pesel = true, miejscowosc = true, kodPocztowy = true,
            ulica = true, numerDomu = true, telefon = true, zdjecie = true;

        let numerMieszkania = this.state.numerMieszkania;

        let regexText = /^[a-zA-Z0-9ęółśążźćńĘÓŁŚĄŻŹĆŃ-]{3,20}$/u;
        let regexNumbers = /^\d+$/;
        let regexPostalCode = /^\d{2}-\d{3}$/;

        if (this.state.imie === null || this.state.imie === '' || this.state.imie.length < 3 || regexText.test(this.state.imie) === false) {
            imie = false
        }
        if (this.state.nazwisko === null || this.state.nazwisko === '' || this.state.nazwisko.length < 3 || regexText.test(this.state.nazwisko) === false) {
            nazwisko = false
        }

        // DODATKOWE

        imie = true
        nazwisko = true

        pesel = true

        let zdjecieShow = this.state.zdjecieShow;

        if (this.state.zdjecieShow === '') {
            zdjecieShow = []
        }

        console.log(this.state.zdjecieShowZapisane)
        console.log(this.state.zdjecieShow)

        if (imie === true && nazwisko === true && pesel === true) {
            LoginService.putRegister(JSON.parse(sessionStorage.getItem('loggedIn')).idKl, JSON.parse(sessionStorage.getItem('loggedIn')).login, JSON.parse(sessionStorage.getItem('loggedIn')).pass,
                this.state.imie, this.state.nazwisko, this.state.pesel, this.state.numerDokumentu, this.state.nrDokWaznyDo, this.state.dataUrodzenia,
                this.state.miejscowosc, this.state.kodPocztowy, this.state.ulica, this.state.numerDomu,
                numerMieszkania, this.state.telefon, zdjecieShow)
                .then(function (response) {
                    this.setState({
                        imieInvalid: !imie,
                        nazwiskoInvalid: !nazwisko,
                        peselInvalid: !pesel,
                        aktualizacjaLoader: false
                    });
                    let zdjecieStorage = '';

                    if (this.state.zdjecieShowZapisane === []) {
                        zdjecieStorage = this.state.zdjecieShow
                    } else {
                        zdjecieStorage = []
                    }

                    console.log(this.state.zdjecieShowZapisane)
                    console.log(this.state.zdjecieShow)
                    console.log(zdjecieStorage)

                    let storage = {
                        idKl: JSON.parse(sessionStorage.getItem('loggedIn')).idKl,
                        imie: this.state.imie,
                        nazwisko: this.state.nazwisko,
                        miejscowosc: this.state.miejscowosc,
                        kodPoczt: this.state.kodPocztowy,
                        nrDok: this.state.nrDok,
                        nrDokWaznyDo: this.state.nrDokWaznyDo,
                        nrDomu: this.state.numerDomu,
                        nrMieszk: numerMieszkania,
                        nrTel: this.state.telefon,
                        pesel: this.state.pesel,
                        ulica: this.state.ulica,
                        pliki: this.state.zdjecieShowZapisane.length !== 0 ? this.state.zdjecieShowZapisane : this.state.zdjecieShow,
                        login: JSON.parse(sessionStorage.getItem('loggedIn')).login,
                        pass: JSON.parse(sessionStorage.getItem('loggedIn')).pass
                    };
                    console.log(storage)
                    sessionStorage.setItem('loggedIn', JSON.stringify(storage))

                    if (sessionStorage.getItem('link') !== null) {
                        window.location.replace(sessionStorage.getItem('link'));
                        sessionStorage.removeItem('link')
                    } else {
                        if (window.location.href.indexOf("konto") > -1) {
                            NotificationManager.success("", "Dane zostały aktualizowane ", 5000)
                            this.setState({zdjecieShow: [], zdjecieShowZapisane: [], loading: false})
                            this.componentWillMount()
                        } else {
                            window.location.reload()
                        }
                    }

                }.bind(this)).catch(err => {
                console.log(err);
            });
        } else {
            this.setState({
                aktualizacjaLoader: false,
                imieInvalid: !imie,
                nazwiskoInvalid: !nazwisko,
                peselInvalid: !pesel,
                miejscowoscInvalid: !miejscowosc,
                ulicaInvalid: !ulica,
                kodPocztowyInvalid: !kodPocztowy,
                numerDomuInvalid: !numerDomu,
                telefonInvalid: !telefon,
                zdjecieInvalid2: !zdjecie
            })
        }
    }

    submit = () => {
        confirmAlert({
            title: 'Usuwanie zdjęcia',
            message: 'Czy na pewno chcesz usunąć zdjęcie z serwera?',
            buttons: [
                {
                    label: 'Tak',
                    onClick: () => this.deleteIstniejacy(this.state.zdjecieShowZapisane[0])
                },
                {
                    label: 'Nie',
                    onClick: () => console.log('Anulowano usunięcie zdjęcia.')
                }
            ]
        });
    };

    render() {
        return <div>{this.state.cropTrue ?
            <div className="componentContainer" style={{position: 'absolute', zIndex: 9999}}>

                <Crop cropItem={this.state.cropItem} setImage={(image) => {
                    this.setState({
                        zdjecieShow:
                            [{
                                dane: image.split(",")[1],
                                dokumentTyp: "KLIENT_ZDJECIE",
                                nazwa: this.state.zdjecieShow2[0].nazwa,
                                typ: this.state.zdjecieShow2[0].typ,
                                rozmiar: this.state.zdjecieShow2[0].rozmiar
                            }],
                        cropTrue: false,

                    });
                    this.closeModal()
                }} zdjecieKlient={true}
                      anuluj={() => this.setState({cropTrue: false})}/>
            </div> : null}
            <div>

                {this.state.loading ? <div className="row" style={{marginTop: 20}}>
                        <div className="col-6 text-center daneOsoboweMobilka">
                            <h5>Dane osobowe</h5>
                            <div className="row daneOsobowe">
                                <div className="col-4 inputLabel">Imię: <font color="red">*</font></div>
                                <div className="col-8 inputLogin text-left"><i className="fa fa-user"> </i>
                                    <input className="form-control inputLoginControl2" value={this.state.imie}
                                           onChange={this.handleImie}
                                           placeholder="Imię"
                                           type="text"/>
                                    {this.state.imieInvalid ?
                                        <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Niepoprawne
                                            imię.</div> : null}</div>
                            </div>
                            <div className="row">
                                <div className="col-4 inputLabel">Nazwisko: <font color="red">*</font></div>
                                <div className="col-8 inputLogin text-left"><i className="fa fa-id-badge"> </i>
                                    <input className="form-control inputLoginControl2" value={this.state.nazwisko}
                                           onChange={this.handleNazwisko}
                                           placeholder="Nazwisko" type="text"/>

                                    {this.state.nazwiskoInvalid ?
                                        <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Niepoprawne
                                            nazwisko.</div> : null}</div>
                            </div>
                            <div className="row">
                                <div className="col-4 inputLabel">Zdjęcie: <font color="#1e90ff">*</font></div>
                                <div className="col-8 inputLogin text-left">
                                    <Dropzone maxSize={2000000} accept="image/jpg,image/jpeg"
                                              disabled={this.state.zdjecieShowZapisane.length !== 0 || this.state.zdjecieShow.length !== 0}
                                              style={{
                                                  maxWidth: '85%',
                                                  height: 150,
                                                  border: '1px dashed #ced4da',
                                                  borderRadius: '0.25rem',
                                                  paddingTop: 15,
                                                  textAlign: 'center',
                                                  fontSize: '0.875rem',
                                                  color: '#565756',
                                                  cursor: 'pointer'
                                              }}
                                              onDrop={(accepted, rejected) => {
                                                  this.onDrop(accepted, rejected)
                                              }}>
                                        {this.state.zdjecieShowZapisane.length !== 0 ?
                                            <div>
                                                {this.state.czyWeryfikacja ? null :
                                                    <i style={{color: 'red', padding: 0, float: 'right'}}
                                                       className="fa fa-times"
                                                       onClick={this.submit}/>}
                                                <img
                                                    src={'data:' + this.state.zdjecieShowZapisane[0].typ + ';base64, ' + this.state.zdjecieShowZapisane[0].dane}
                                                    height={100}/>
                                            </div> : <div>
                                                {this.state.zdjecieInvalid ?
                                                    <div>
                                                        <div style={{paddingTop: '6%', color: 'red'}}>Plik zdjęcia jest
                                                            niepoprawny!
                                                        </div>
                                                        <div style={{color: 'red'}}>Akceptowane pliki .jpg (max. 2mb)</div>
                                                        <div>(Kliknij by wybrać zdjęcie)</div>
                                                    </div>
                                                    : <div>
                                                        {this.state.zdjecieShow.length !== 0 ? <div>
                                                                {this.state.czyWeryfikacja ? null :
                                                                    <i style={{color: 'red', padding: 0, float: 'right'}}
                                                                       className="fa fa-times" onClick={() => {
                                                                        this.deleteNowy(this.state.zdjecieShow[0]);
                                                                    }}/>}
                                                                <img
                                                                    src={'data:' + this.state.zdjecieShow[0].typ + ';base64, ' + this.state.zdjecieShow[0].dane}
                                                                    height={100} style={{maxWidth: '90%'}}/>
                                                            </div> :
                                                            <div>
                                                                <div style={{paddingTop: '12%'}}>Akceptowane pliki .jpg (max
                                                                    2mb)
                                                                </div>
                                                                <div>(Kliknij by wybrać zdjęcie)</div>
                                                            </div>
                                                        }
                                                    </div>}
                                            </div>}
                                    </Dropzone>
                                    {this.state.zdjecieInvalid2 ?
                                        <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy dodać
                                            zdjęcie w celu weryfikacji.</div> : null}

                                </div>
                            </div>
                        </div>
                        <div className="col-6 text-center daneOsoboweMobilka" style={{borderLeft: '1px solid #e0e0e0'}}>
                            <h5>Dane kontaktowe</h5>
                            <div className="row">
                                <div className="col-4 inputLabel">Miejscowość: <font color="#1e90ff">*</font></div>
                                <div className="col-8 inputLogin text-left"><i className="fa fa-map-marker"> </i>
                                    <input className="form-control inputLoginControl2" value={this.state.miejscowosc}
                                           onChange={this.handleMiejscowosc}
                                           placeholder="Miejscowość"
                                           type="text"/>
                                    {this.state.miejscowoscInvalid ?
                                        <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Niepoprawna
                                            nazwa
                                            miejscowości.</div> : null}</div>
                            </div>
                            <div className="row">
                                <div className="col-4 inputLabel">Kod pocztowy: <font color="#1e90ff">*</font></div>
                                <div className="col-8 inputLogin text-left"><i className="fa fa-location-arrow"> </i>
                                    <input className="form-control inputLoginControl2" value={this.state.kodPocztowy}
                                           onChange={this.handleKodPocztowy}
                                           placeholder="Kod pocztowy" type="text"/>
                                    {this.state.kodPocztowyInvalid ?
                                        <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Niepoprawny
                                            kod
                                            pocztowy.</div> : null}</div>
                            </div>
                            <div className="row">
                                <div className="col-4 inputLabel">Ulica: <font color="#1e90ff">*</font></div>
                                <div className="col-8 inputLogin text-left"><i className="fa fa-road"> </i>
                                    <input className="form-control inputLoginControl2" value={this.state.ulica}
                                           onChange={this.handleUlica}
                                           placeholder="Ulica" type="text"/>
                                    {this.state.ulicaInvalid ?
                                        <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Niepoprawna
                                            nazwa
                                            ulicy.</div> : null}</div>
                            </div>
                            <div className="row">
                                <div className="col-4 inputLabel">Numer domu: <font color="#1e90ff">*</font></div>
                                <div className="col-8">
                                    <div className="row">
                                        <div className="col-6 inputLogin text-left" style={{paddingRight: 0}}><i
                                            className="fa fa-home displayNoneMobilka"> </i>
                                            <input className="form-control inputLoginControl2"
                                                   value={this.state.numerDomu}
                                                   onChange={this.handleNumerDomu}
                                                   type="text"/></div>
                                        <div className="col-6 inputLogin text-left" style={{paddingLeft: 0}}><i
                                            className="fa fa-building"> </i>
                                            <input className="form-control inputLoginControl2" style={{width: '50%'}}
                                                   value={this.state.numerMieszkania}
                                                   onChange={this.handleNumerMieszkania}
                                                   type="text"/></div>
                                    </div>
                                    {this.state.numerDomuInvalid ?
                                        <div className="niepoprawneDaneOsobowe text-left"
                                             style={{fontSize: '0.875rem'}}>Niepoprawny numer
                                            domu.</div> : null}</div>
                            </div>
                            <div className="row">
                                <div className="col-4 inputLabel">Telefon: <font color="#1e90ff">*</font></div>
                                <div className="col-8 inputLogin text-left"><i className="fa fa-phone"> </i>
                                    <input className="form-control inputLoginControl2" value={this.state.telefon}
                                           onChange={this.handleTelefon}
                                           placeholder="Telefon" type="text"/>
                                    {this.state.telefonInvalid ?
                                        <div className="niepoprawneDaneOsobowe"
                                             style={{fontSize: '0.875rem'}}>Niepoprawny numer
                                            telefonu.</div> : null}</div>
                            </div>
                        </div>
                        {this.state.czyWeryfikacja ? <div className={"col-12"} style={{
                            marginTop: 10,
                            textAlign: "center",
                            color: 'red',
                            fontSize: "0.75rem"
                        }}>UWAGA! Brak możliwości edycji zdjęcia podczas procesu weryfikacji nowej karty biletu
                            miesięcznego.</div> : null}
                        {/*<div className="col-12">*/}
                        {/*    <div className={'row'}>*/}
                        {/*        <div className={'col-2'}></div>*/}
                        {/*        <div className="col-2 inputLabel">Pesel:*/}
                        {/*            /!*<font color="#1e90ff">*</font>*!/*/}
                        {/*        </div>*/}
                        {/*        <div className="col-6 inputLogin text-left"><i className="fa fa-id-card"> </i>*/}
                        {/*            <input className="form-control inputLoginControl2" value={this.state.pesel}*/}
                        {/*                   onChange={this.handlePesel}*/}
                        {/*                   placeholder="Pesel" type="text"/>*/}
                        {/*            {this.state.peselInvalid ?*/}
                        {/*                <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Niepoprawny*/}
                        {/*                    pesel.</div> : null}</div>*/}
                        {/*        <div className="col-12 text-center" style={{fontSize: '0.75rem', color: '#1e90ff'}}>*/}
                        {/*            Pole nieobowiązkowe, wymagane do zakupu biletu miesięcznego ze zniżką*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className="col-12 text-center">
                            <div className="buttonLogin"><Button bsStyle="success"
                                                                 onClick={() => this.dokonczRejestracje()}>Aktualizuj
                                dane</Button>
                                {this.state.aktualizacjaLoader ? <div className="loaderDim" style={{textAlign: 'center'}}><i
                                    className="fa fa-spinner fa-pulse fa-fw"
                                    style={{
                                        color: '#58b13d'
                                    }}> </i></div> : null}
                            </div>
                        </div>
                        <div className="col-12 text-center">
                            <div style={{marginTop: 10, textAlign: "center", color: "red", fontSize: "0.75rem"}}>Pola
                                wymagane do kontaktu z BOK i oceny przejazdu oznaczono *
                            </div>
                            <div style={{textAlign: "center", color: "#1e90ff", fontSize: "0.75rem"}}>Pola wymagane do
                                założenia karty i zakupu biletu miesięcznego oznaczono *
                            </div>
                        </div>

                    </div>

                    :
                    <div>
                        <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                            className="fa fa-spinner fa-pulse fa-2x fa-fw"
                            style={{
                                color: '#58b13d'
                            }}> </i></div>
                    </div>}</div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/kontoComponents/RejestracjaComponent.js